/**
 * APT 데이터 비교(누적) — 회차별 항목 시리즈 빌드 순수함수
 * SPEC: docs/IPT-545-SPEC.md (데이터 비교)
 *
 * 요구사항: 비교가 아닌 "누적". 비교 대상은 회차. 증/감 없이 회차별 값을 그대로 누적.
 * 각 항목(미열람/메일열람/링크클릭/정보입력/스팸신고)을 회차 축으로 나열한다.
 */

import { AptStats, normalizeAptStats } from './aptCompare';

export type CumulativeKey =
  | 'unread'
  | 'emailOpened'
  | 'linkClicked'
  | 'infoInput'
  | 'spamReport';

export interface CumulativeItem {
  key: CumulativeKey;
  label: string;
}

// 고정 순서 — 세로 나열 그래프 및 표의 행 순서
export const CUMULATIVE_ITEMS: CumulativeItem[] = [
  { key: 'unread', label: '미열람' },
  { key: 'emailOpened', label: '메일열람' },
  { key: 'linkClicked', label: '링크클릭' },
  { key: 'infoInput', label: '정보입력' },
  { key: 'spamReport', label: '스팸신고' },
];

export interface CumulativeSeries extends CumulativeItem {
  values: number[]; // rounds와 같은 길이, rounds[i] 회차의 항목 값
}

export interface CumulativeData {
  rounds: string[];
  series: CumulativeSeries[];
}

export function buildCumulative(
  roundsAsc: string[],
  statsByRound: Record<string, Partial<AptStats> | undefined>,
): CumulativeData {
  const normalized = roundsAsc.map((r) => normalizeAptStats(statsByRound[r]));

  const series: CumulativeSeries[] = CUMULATIVE_ITEMS.map((item) => ({
    ...item,
    values: normalized.map((stat) => stat[item.key]),
  }));

  return { rounds: [...roundsAsc], series };
}
